export const conversation = "Tyc";
export const conversations = "Uyc";
export const item = "Vyc";
export const items = "Wyc";
export default {conversation,conversations,item,items};